import { render, staticRenderFns } from "./RestrictionDatePicker.vue?vue&type=template&id=06efddb2"
import script from "./RestrictionDatePicker.vue?vue&type=script&lang=js"
export * from "./RestrictionDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports